import api from '~api'
import { convertPages, convertJobDetailsResponse } from '~utils/api'

export const url = `/job`
const convertParams = {
  keywords: 'query',
  category: 'category_id',
  region: 'country_id',
  subregion: 'area',
  identity: 'identity_id',
  department: 'department_id',
  page: 'page'
}
const convertParamsKeys = Object.keys(convertParams)

export async function getJobCategories () {
  const {
    data
  } = await api.get(`${url}/categories`)

  const categories = data.data.map((category) => {
    return {
      category_name: category.name,
      category_value: category.id
    }
  })
  return (categories)
}

export async function getJobIdentities () {
  const {
    data
  } = await api.get(`${url}/identities`)

  const identities = data.data.map((identity) => {
    return {
      identity_name: identity.name,
      identity_value: identity.id
    }
  })
  return (identities)
}

export async function getJobDepartments () {
  const {
    data
  } = await api.get(`${url}/departments`)

  const departments = data.data.map((department) => {
    return {
      department_name: department.name,
      department_value: department.id
    }
  })

  return (departments)
}

export async function getJobsByParameters (params = {}) {
  const newParams = {}
  if (Object.keys(params).length) {
    Object.keys(params).forEach(param => {
      if (convertParamsKeys.includes(param)) {
        newParams[convertParams[param]] = params[param]
      }
    })
  }
  const {
    data
  } = await api.get(`${url}/list`, {
    params: newParams
  })

  const jobs = data.data.map((job) => {
    return {
      job_title: job.name,
      job_company: job.enterprise.name,
      job_id: job.id,
      job_published_at: job.created_at,
      job_industry: job.enterprise.jobCategory.name,
      job_identity: (job.identities.length) ? job.identities[0].name : '',
      job_region: job.country.name
    }
  })

  const pages = convertPages(data.meta)

  return ({
    jobs,
    pages
  })
}

export async function getJobById (id) {
  const {
    data
  } = await api.get(`${url}/list/${id}`)

  const response = data.data

  const job = convertJobDetailsResponse(response)

  return (job)
}
